export const COOKIE_KEYS = {
  SIMULATED_SUPPLIER_ID: "simsid",
  SIMULATED_SUPPLIER_NAME: "simname",
  SIMULATED_SUPPLIER_LOGO: "simlogo",
  SIMULATED_SUPPLIER_TAX: "simtax"
};